import { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { EmptyState } from "../../components/EmptyState";
import { api, type TrendSeries } from "../../lib/api";

export default function TrendsSleep() {
  const [data, setData] = useState<TrendSeries | null | "error">(null);

  useEffect(() => {
    api.trends
      .sleep(30)
      .then(setData)
      .catch(() => setData("error"));
  }, []);

  const points = data && data !== "error" ? data.points : [];
  const hasData = points.some((p) => p.value !== null);

  return (
    <div>
      <h2 className="section-title mb-4">Sleep</h2>

      {data === null ? (
        <p className="muted">Loading...</p>
      ) : !hasData ? (
        <EmptyState error={data === "error"} title="No sleep history yet">
          Sleep duration and score build this trend once the Galaxy/Garmin pipe
          is connected.
        </EmptyState>
      ) : (
        <div className="card card-pad">
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={points}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#e7e5e4"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                axisLine={false}
                tickLine={false}
                fontSize={11}
              />
              <YAxis axisLine={false} tickLine={false} width={36} />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="value"
                name="Sleep hours"
                stroke="#9a3412"
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
